/**
 * SHADOW of core's title block view — stands down on the browse containers.
 * (item 15)
 *
 * Those pages render their heading from components/Layout/PageHeader, mounted
 * by the browse shell. The shell is the only place that knows whether a
 * `?preset=` is active, so it is the only place that can title the page
 * "Archived Standards" rather than "Documents". Before this, opening
 * `/documents?preset=archives-browse` gave you a `<title>` tag saying "Archived
 * Standards", an active category pill saying "Archived Standards", and an h1
 * saying "Documents" — the page contradicting itself about what it was.
 *
 * Rendering `null` rather than hiding the h1 with CSS: a hidden h1 is still in
 * the accessibility tree and the document outline, so the page would have two
 * competing headings for anyone not looking at it.
 *
 * Keyed on the same `family` stamp the browse shell keys on (written by
 * scripts/audit/generate_canonical_browse_blocks.py), so every other page
 * carrying a title block — news, help, contact, the document views — is
 * untouched.
 */
import React from 'react';

const isBrowseContainer = (content) =>
  Object.values(content?.blocks || {}).some(
    (b) => b?.['@type'] === 'search' && !!b?.family,
  );

const TitleBlockView = ({ properties, metadata }) => {
  if (isBrowseContainer(properties)) return null;
  return (
    <h1 className="documentFirstHeading">
      {(metadata || properties)?.title || ''}
    </h1>
  );
};

export default TitleBlockView;
